import { render, staticRenderFns } from "./MetodosPagamento.vue?vue&type=template&id=75897f00&scoped=true&"
import script from "./MetodosPagamento.vue?vue&type=script&lang=js&"
export * from "./MetodosPagamento.vue?vue&type=script&lang=js&"
import style0 from "./MetodosPagamento.vue?vue&type=style&index=0&id=75897f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75897f00",
  null
  
)

export default component.exports